import { render, staticRenderFns } from "./DbConnectionMonitor.vue?vue&type=template&id=38578aa4&scoped=true"
import script from "./DbConnectionMonitor.vue?vue&type=script&lang=js"
export * from "./DbConnectionMonitor.vue?vue&type=script&lang=js"
import style0 from "./DbConnectionMonitor.vue?vue&type=style&index=0&id=38578aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38578aa4",
  null
  
)

export default component.exports